export enum CalendarIdPrefixes {
    calendar,
    section,
    block,
    track,
    event
}
